module.exports = __webpack_public_path__ + "assets/img/vip3.89cb25ed.jpg";